import React, { useEffect, useState } from 'react'
import { FlatList, View } from 'react-native'
import { Button, color, iconCreate, Post, SvgIcon, Text } from '@trivie/ui-mobile'
import { observer } from 'mobx-react-lite'
import { Avatar } from '@trivie/ui-web/components/avatar'
import { useStores, setPageTitle } from '@trivie/core'
import { ViewStyle } from 'react-native'
import { CreatePostDialog } from '../../talk/talk-screen/create-post-dialog'
import { useHistory } from 'react-router'

export interface HistoryProps {
  topicId?: number | undefined
}

interface RecentPostsProps {
  assignmentID: number
  topicID: number
  visible?: boolean
}
export const RecentPosts = observer((props: RecentPostsProps) => {
  const { assignmentID, visible, topicID } = props
  const { userStore, talkStore, libraryStore, resourceStore, formStore } = useStores()
  const { setFormData } = formStore
  const { user, getTalkPermission } = userStore
  const { selectedTopic, getTopicDetail, getTopicsForUser } = libraryStore
  const { setLoadingResourcePost } = resourceStore
  const { createPost, refreshTopicPosts, refreshPosts, sortedTopicPosts, likePost, deletePost } =
    talkStore
  const [canPost, setCanPost] = useState(false)
  const [showPostDialog, setShowPostDialog] = useState(false)
  const history = useHistory()

  // added from recent posts
  const goToComments = (postId: any) => history.push(`/talk/${postId}`)
  const goToPosts = () => history.push('/talk', { topicId: topicID })
  const onLike = (postId: number) => {
    likePost(postId)
  }
  const onComment = (postId: any) => {
    talkStore.refreshPost(postId).then((data: any) => {
      if (data.resources) {
        talkStore.setSelectedPostPhoto(data.resources)
      }
      goToComments(postId)
    })
  }
  const onTogglePin = () => {
    const shouldRefresh = selectedTopic && refreshTopicPosts(selectedTopic?.topic_id)
    if (shouldRefresh) {
      refreshPosts()
    }
  }

  const onDelete = (postId: number) => {
    deletePost(postId).then(() => {
      if (userStore.user) {
        // getTopicDetail(userStore.user.id, assignmentID, topicID)
      }
    })
  }
  // end recent posts additions

  useEffect(() => {
    const content = document.getElementById('rootContent')
    if (content) {
      content.style.overflow = 'hidden'
    }

    if (user) {
      setCanPost(getTalkPermission('can_create_post'))
      getTopicsForUser(user.id)
      refreshPosts()
    }
    setPageTitle(`Feed - ${process.env.REACT_APP_SITE_TITLE}`)
  }, [])

  const renderPost = ({ item, index }: { item: any; index: number }) => {
    const photos = [] as any
    let video
    if (item.resources && item.resources.length > 0) {
      item.resources.forEach((resource: any) => {
        if (
          ['jpg', 'jpeg', 'png', 'gif'].includes((resource.extension ?? '').toLocaleLowerCase())
        ) {
          photos.push(resource)
        } else {
          video = resource
        }
      })
    }

    return photos && photos.length > 0 ? (
      <Post
        type="photo"
        title={`${item.author.first_name} ${item.author.last_name}`}
        subtitle={item.title}
        avatar={item.author?.photo_url}
        post={item}
        onComment={() => {
          onComment(item.id)
        }}
        onLike={() => onLike(item.id)}
        onDelete={() => onDelete(item.id)}
        onTogglePin={refreshPosts}
        index={index}
        photos={photos}
        noPadding
      />
    ) : video ? (
      <Post
        type="video"
        title={`${item.author.first_name} ${item.author.last_name}`}
        subtitle={item.title}
        avatar={item.author?.photo_url}
        post={item}
        onComment={() => {
          onComment(item.id)
        }}
        onLike={() => onLike(item.id)}
        onDelete={() => onDelete(item.id)}
        onTogglePin={refreshPosts}
        index={index}
        currentViewableIndex={0}
        noPadding
      />
    ) : (
      <Post
        type="text"
        title={`${item.author.first_name} ${item.author.last_name}`}
        subtitle={item.title}
        avatar={item.author?.photo_url}
        post={item}
        onComment={() => {
          onComment(item.id)
        }}
        onLike={() => onLike(item.id)}
        onDelete={() => onDelete(item.id)}
        onTogglePin={refreshPosts}
        index={index}
        noPadding
      />
    )
  }

  const params = history.location.state as HistoryProps

  return visible ? (
    <>
      <FlatList
        ListHeaderComponent={
          <View
            accessibilityRole="image"
            accessibilityLabel={`${user?.first_name} ${user?.last_name} profile picture`}
            style={SUBHEADER}
          >
            <Avatar
              style={{ marginRight: 20 }}
              size="small"
              source={user?.photo_url}
              name={`${user?.first_name} ${user?.last_name}`}
            />
            {canPost && (
              <Button
                accessibilityRole="button"
                accessibilityLabel="Open create post pop up"
                style={{
                  flex: 1,
                  backgroundColor: '#EBEBEB',
                  height: 36,
                  borderRadius: 8,
                  marginLeft: 16,
                }}
                onPress={() => {
                  setFormData({})
                  formStore.setVideo(false)
                  setShowPostDialog(true)
                }}
              >
                <View style={{ flexDirection: 'row', alignSelf: 'center', alignItems: 'center' }}>
                  <SvgIcon color="#000" viewBox="0 0 24 24" src={iconCreate} size={16} />
                  <Text
                    style={{ color: color.black, paddingLeft: 10, fontWeight: '600' }}
                    tx="Discuss.create"
                    variant="body1Medium"
                  />
                </View>
              </Button>
            )}
          </View>
        }
        style={{ marginBottom: 30 }}
        showsVerticalScrollIndicator={false}
        data={sortedTopicPosts}
        renderItem={renderPost}
        keyExtractor={(post) => post.post_id + ''}
        ItemSeparatorComponent={() => <View style={{ marginHorizontal: 20, height: 8 }} />}
      />
      {showPostDialog && (
        <CreatePostDialog
          selectedTopicId={selectedTopic?.topic_id ?? undefined}
          onClose={() => {
            setShowPostDialog(false)
            refreshTopicPosts(selectedTopic?.topic_id)
          }}
          open={showPostDialog}
        />
      )}
    </>
  ) : null
})

const SUBHEADER: ViewStyle = {
  flexDirection: 'row',
  flexWrap: 'nowrap',
}
